import React from 'react';
import { Container } from 'react-bootstrap';
import guionesImage from '../data/inicio/Guiones.png'; 
import ia from '../data/inicio/IA.png'; 
import web from '../data/inicio/Web.png'; 
import ciber from '../data/inicio/Ciber.png'; 
import './ProjectsSection.css';

const ProjectsSection = () => {
  const learningModules = [
    { 
      id: 1, 
      title: 'Creación de Guiones para Redes Sociales', 
      image: guionesImage,
      description: 'Domina narrativas breves con ganchos emocionales y CTAs persuasivos. Incluye plantillas prácticas para TikTok y análisis de casos reales.',
      tags: ['Storytelling', 'Técnicas Persuasivas', 'Ejemplos Prácticos'],
      link: '#'
    },
    { 
      id: 2, 
      title: 'Interacción con Inteligencia Artificial', 
      image: ia,
      description: 'Aprende prompting avanzado (Zero-shot, CoT, RAG) y análisis ético para evitar sesgos en respuestas de IA.',
      tags: ['Prompting', 'Ética en IA', 'Adaptación Cultural'],
      link: '#'
    },
    { 
      id: 3, 
      title: 'Desarrollo Web Profesional', 
      image: web,
      description: 'Desde HTML/CSS hasta arquitecturas MVC y Web Components. Comparativa de tecnologías estáticas vs dinámicas.',
      tags: ['Frontend', 'Frameworks', 'Arquitectura'],
      link: '#'
    },
    { 
      id: 4, 
      title: 'Ciberciudadanía Responsable', 
      image: ciber,
      description: 'Privacidad digital, combate de deepfakes y adopción de software libre. Casos reales de implementación en LATAM.',
      tags: ['Seguridad', 'Ética Digital', 'FLOSS'],
      link: '#'
    }
  ];

  return (
    <section className="projects-section" id="aprendizaje">
      <Container className="projects-container">
        <h2 className="section-title">Habilidades que Dominarás</h2>
        
        <div className="projects-list">
          {learningModules.map((module) => (
            <div className="project-card" key={module.id}>
              <div className="project-image">
                <img
                  src={module.image}
                  alt={`Módulo ${module.title}`}
                />
              </div>
              
              <div className="project-content">
                <h3>{module.title}</h3>
                <p>{module.description}</p>
                
                <div className="project-meta">
                  {module.tags.map((tag, index) => (
                    <span key={index}>{tag}</span>
                  ))}
                </div>
                
                <a href={module.link} className="project-link">
                  Ver módulo
                </a>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default ProjectsSection;